import { ArrowUpRight, Smartphone } from "lucide-react";
import { Reveal } from "./Reveal";
import { MOBILE_APPS } from "../lib/data";

export const MobileApps = () => {
  return (
    <section id="apps" className="py-24 lg:py-32" data-testid="apps-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand mb-6">Mobile apps</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink max-w-3xl">
            Apps live on <span className="text-gradient">Google Play.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {MOBILE_APPS.map((a, i) => (
            <Reveal key={a.name} delay={i * 0.08} className="h-full">
              <a
                href={a.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group h-full glass rounded-3xl p-8 hover:-translate-y-1.5 transition-transform duration-300 flex flex-col"
                data-testid={`app-card-${i}`}
              >
                <div className="flex items-center gap-4 mb-6">
                  {a.icon ? (
                    <img src={a.icon} alt={`${a.name} app icon`} loading="lazy" className="w-16 h-16 rounded-2xl object-cover shadow-lg shadow-brand/10" />
                  ) : (
                    <div className="w-16 h-16 rounded-2xl btn-gradient flex items-center justify-center shadow-lg shadow-brand/20">
                      <span className="font-display font-extrabold text-2xl text-white">{a.initial}</span>
                    </div>
                  )}
                  <div>
                    <h3 className="font-display font-semibold text-xl text-ink group-hover:text-brand transition-colors">{a.name}</h3>
                    <p className="text-sm text-ink-soft">{a.tagline}</p>
                  </div>
                </div>
                <p className="text-ink-soft font-light text-[15px] flex-1">{a.desc}</p>
                <div className="mt-6 flex items-center justify-between">
                  <span className="inline-flex items-center gap-2 text-xs font-medium text-ink-soft">
                    <Smartphone className="w-4 h-4 text-brand" /> {a.meta}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-gradient">
                    Google Play <ArrowUpRight className="w-4 h-4 text-brand" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
